var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('SignInForm',{attrs:{"dict":_vm.dict}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }